
import { ISavingsFixedBalances, TSavingsFixedBalances } from 'app/calcs/retirementSavings';
import { getChartData } from 'app/calcs/RetirementSavingsAnalyzer'
import * as utils from 'app/utils'
import * as Highcharts from 'highcharts'
import * as _ from 'lodash'
import * as moment from 'moment'

function pointFormatter() {
  const y = Math.floor(this.x)
  const m = (this.x % 1) * 12
  const w = moment({ years: y, months: m })
  // tslint:disable-next-line:no-debugger
  //debugger
  return w.format('MMM, YYYY') + ': ' + this.point.extraStuff
}

const memberContributionsChart: Highcharts.Options = {
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie'
  },

  title: {
    text: ''
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
  },
  plotOptions: {
    pie: {
      showInLegend: true,
      animation: { duration: 1000 },
      cursor: 'pointer',
      colors: ['#8dc248', '#26a69a', '#23282d', '#F37402', '#8dc248', '#64E572', '#FF9655', '#FFF263', '#6AF9C4'],
      dataLabels: {
        enabled: false,
        format: '<b>{point.name}</b>: $\{point.percentage:.1f} ',
      }
    }
  },
  credits: {
    enabled: false
  },
  series: [{
    name: 'Contributions',
    data: null
  }]
}

const getMemberContributionsChart = (labels: utils.HashedThings<TSavingsFixedBalances, string>, retirementSavings = 0, fourxxBalance = 0, iraBalance = 0, personalSavings = 0, healthReimbursementAccount = 0) => {
  const labelFor = (key: TSavingsFixedBalances, def: string) => {
    if (!labels) { return def }
    return labels[key] ? labels[key] : def
  }
  const total = retirementSavings + fourxxBalance + iraBalance + personalSavings + healthReimbursementAccount
  let retirementSavingsPercentage = _.divide(retirementSavings, total)
  let fourxxBalancePercentage = _.divide(fourxxBalance, total)
  let iraBalancePercentage = _.divide(iraBalance, total)
  let personalSavingsPercentage = _.divide(personalSavings, total)
  let healthReimbursementAccountPercentage = _.divide(healthReimbursementAccount, total)
  const data: Highcharts.DataPoint[] = []

  retirementSavingsPercentage = retirementSavingsPercentage === Infinity ? 0 : retirementSavingsPercentage * 100
  fourxxBalancePercentage = fourxxBalancePercentage === Infinity ? 0 : fourxxBalancePercentage * 100
  iraBalancePercentage = iraBalancePercentage === Infinity ? 0 : iraBalancePercentage * 100
  personalSavingsPercentage = personalSavingsPercentage === Infinity ? 0 : personalSavingsPercentage * 100
  healthReimbursementAccountPercentage = healthReimbursementAccountPercentage === Infinity ? 0 : healthReimbursementAccountPercentage * 100

  if (retirementSavingsPercentage) {
    data.push({
      name: labelFor('retirementSavings', 'Savings Balance'),
      y: retirementSavingsPercentage
    })
  }

  if (fourxxBalancePercentage) {
    data.push({
      name: labelFor('fourxxBalance', '401(k), 403(b), 457 Plan Balance'),
      y: fourxxBalancePercentage
    })
  }

  if (iraBalancePercentage) {
    data.push({
      name: labelFor('iraBalance', 'IRA Balance'),
      y: iraBalancePercentage
    })
  }

  if (personalSavingsPercentage) {
    data.push({
      name: labelFor('personalSavings', 'Personal Savings'),
      y: personalSavingsPercentage
    })
  }

  if (healthReimbursementAccountPercentage) {
    data.push({
      name: labelFor('healthReimbursementAccount', 'Health Reimbursement Account'),
      y: healthReimbursementAccountPercentage
    })
  }

  const nextChart = memberContributionsChart
  nextChart.series[0].data = data

  return nextChart
}

const getPersonalWithdrawalChart = (analysis) => ({
  colors: ['#8dc248', '#26a69a', '#23282d', '#F37402', '#8dc248', '#64E572',
    '#FF9655', '#FFF263', '#6AF9C4'],
  chart: {
    type: 'area'
  },
  credits: {
    enabled: false
  },
  legend: {
    enabled: false
  },
  title: {
    text: false,
  },
  xAxis: {
    allowDecimals: false,
    title: {
      text: 'Year',
    },
    labels: {
      formatter() {
        return this.value; // clean, unformatted number for year
      }
    }
  },
  yAxis: {
    title: {
      text: 'Account balance',
    },
    labels: {
      formatter() {
        return `$${this.value.toLocaleString()}`;
      }
    }
  },
  tooltip: {
    formatter: pointFormatter
  },
  plotOptions: {
    area: {
      fillColor: {
        linearGradient: [0, 0, 0, 300],
        stops: [
          [0, '#8DC248'],
          [1, 'rgba(141,194,72,0.15)']
        ]
      },
      pointStart: 2018,
      marker: {
        enabled: false,
        symbol: 'circle',
        radius: 2,
        states: {
          hover: {
            enabled: true
          }
        }
      }
    }
  },
  series: [{
    name: 'retirement',
    data: getChartData(analysis)
  }]
})

export {
  getMemberContributionsChart,
  getPersonalWithdrawalChart
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Retirement/charts/index.ts